import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/login/components/login.component';
import { AuthComponent } from './auth.component';
import { LayoutComponent } from './layout.component';
import { AuthGuard } from './services/auth.guard';
import { RoleAuthGuard } from './services/role-auth.guard';
import { CallbackComponent } from './modules/login/callback/callback.component';
import { RoleBasedRedirectComponent } from './components/role-based-redirect/role-based-redirect.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { BackendDownComponent } from './components/backend-down/backend-down.component';

// sets up routes constant where you define your routes
const routes: Routes = [
  {
    path: '', component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: RoleBasedRedirectComponent, pathMatch: 'full' },
      { path: 'access-denied', component: AccessDeniedComponent },
      {
        path: 'brands',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/brands/brands.module').then(m => m.BrandsModule)
      },
      {
        path: 'clients',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/clients/clients.module').then(m => m.ClientsModule)
      },
      {
        path: 'customers',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/customers/customers.module').then(m => m.CustomersModule)
      },
      {
        path: 'locations',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/locations/locations.module').then(m => m.LocationsModule)
      },
      {
        path: 'usermanagement',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/usermanagement/usermanagement.module').then(m => m.UsermanagementModule)
      },
      {
        path: 'devicetemplate',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/devicetemplate/devicetemplate.module').then(m => m.DeviceTemplateModule)
      },
      {
        path: 'alerts',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/alerts/alerts.module').then(m => m.AlertsModule)
      },
      {
        path: 'devices',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/devices/devices.module').then(m => m.DevicesModule)
      },
      {
        path: 'firmware',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/firmware/firmware.module').then(m => m.FirmwareModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'management',
        loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule)
      },
      {
        path: 'scheduler',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/new-scheduler/new-scheduler.module').then(m => m.NewSchedulerModule)
      },
      {
        path: 'jitprules',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/jitprules/jitprules.module').then(m => m.JitpRulesModule)
      },
      {
        path: 'rules',
        canActivate: [RoleAuthGuard],
        loadChildren: () => import('./modules/rules/rules.module').then(m => m.RulesModule)
      },
    ]
  },
  {
    path: 'login', component: AuthComponent,
    children: [
      { path: '', component: LoginComponent }
    ]
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'backend-down',
    component: BackendDownComponent
  },

  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
